module.exports = __webpack_public_path__ + "img/Frame 5130.b9a5ad75.jpg";